import React from "react";
import { useSelector } from "react-redux";
import i18n from "i18next";
import k from "src/i18n/keys";
import { getLocationType } from "src/reducers";
import { Location } from "src/types";
import Groups from "./Groups";
import People from "./People";
import { ContactsContainer, HeadingWrapper } from "./styles";
import Tabs from "./Tabs";
import { Heading } from "@unifize/sarah";

const Contacts = (): React.ReactElement => {
  const locationType = useSelector(({ location }: { location: Location }) =>
    getLocationType(location),
  );

  const isGroupsTab = locationType === "SET_GROUPS_REQUEST";

  return (
    <ContactsContainer>
      <HeadingWrapper>
        <Heading variant="h5">{i18n.t(k.CONTACTS)}</Heading>
      </HeadingWrapper>
      <Tabs tab={isGroupsTab ? "groups" : "people"} />
      {isGroupsTab ? <Groups /> : <People />}
    </ContactsContainer>
  );
};

export default Contacts;
